import {MaxSize} from "../../state/maxsize";

export const Summary = (width: number, height: number, maxSize: MaxSize, textSize: number ) => {
    if (width === 0) {
        return false;
    }

    const winwidth = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    const winheight = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;

    const maxWidth = winwidth >= maxSize.width + maxSize.padding * 2 ? maxSize.width : winwidth - maxSize.padding * 2;
    const maxHeight = winheight >= maxSize.height + maxSize.padding * 2 + 20 ? maxSize.height : winheight - maxSize.padding * 2 - textSize;


    const pomer = height / width;

    if (maxHeight < height) {
        height = maxHeight;
        width = height * (1/pomer);
    }
    if (maxWidth < width ) {
        width = maxWidth;
        height = width * pomer;
    }

    const left = winwidth/2 - width/2;
    const top = winheight/2 - height/2;

    return {
        width,
        height,
        left,
        top
    }
}